import PubSub from '@aws-amplify/pubsub';
import Auth from '@aws-amplify/auth';
import API from '@aws-amplify/api';
import Storage from '@aws-amplify/storage';
import { DevQIoTProvider } from './DevQIotProvider';
import { v4 as uuid } from 'uuid';

//Amplify.Logger.LOG_LEVEL = 'VERBOSE';
const provider = new DevQIoTProvider({
  clientId: 'ipway-' + uuid(),
  aws_pubsub_region: 'eu-central-1',
  aws_pubsub_endpoint:
    'wss://a128sd9dlbv9tq-ats.iot.eu-central-1.amazonaws.com/mqtt'
});
PubSub.addPluggable(provider);
export default provider;

API.configure({
  endpoints: [
    {
      region: 'eu-central-1',
      name: 'ipWayAPI',
      endpoint:
        'https://f19x0pn3w1.execute-api.eu-central-1.amazonaws.com/development'
    }
  ]
});

Auth.configure({
  region: 'eu-central-1',
  identityPoolId: 'eu-central-1:450e5aff-f238-4a47-8f81-9fd55b1bf2d1',
  identityPoolRegion: 'eu-central-1',
  userPoolId: 'eu-central-1_4p2CynQ8i',
  userPoolWebClientId: '7ehd8r1s7u282789cunt65atpg',
  oauth: {}
});

Storage.configure({
  AWSS3: {
    bucket: 'ipway-userfiles-mobilehub-farfisa', //Your bucket name;
    region: 'eu-central-1',
    level: 'private'
  }
});
